import type { ModelsClub } from '@/api/generated-api'
import api from '@/shared/api/client'

export const CLUBS_LIST_PAGE_LIMIT = 100

/**
 * BAT-1214: which participants GET /v2/clubs lists — clubs (the default every
 * showcase relies on), athletes or both (the favourite picker).
 */
export type ParticipantFilter = 'all' | 'club' | 'athlete'

type ClubsListQuery = NonNullable<Parameters<typeof api.v2ClubsList>[0]> & {
  /** Not in the generated client until the next codegen. */
  participant_type?: ParticipantFilter
}

type ClubsListParams = {
  sportTypeId?: string
  search?: string
  offset?: number
  participantType?: ParticipantFilter
}

export async function fetchClubsListPage({
  sportTypeId,
  search,
  offset = 0,
  participantType
}: ClubsListParams) {
  const query: ClubsListQuery = {
    limit: CLUBS_LIST_PAGE_LIMIT,
    offset,
    ...(search ? { search } : {}),
    ...(sportTypeId ? { sport_type: sportTypeId } : {}),
    // Absent = clubs only, as before.
    ...(participantType && participantType !== 'club'
      ? { participant_type: participantType }
      : {})
  }
  return api.v2ClubsList(query)
}

export async function fetchClubsSearch({
  sportTypeId,
  search,
  participantType
}: {
  sportTypeId?: string
  search: string
  participantType?: ParticipantFilter
}): Promise<ModelsClub[]> {
  const response = await fetchClubsListPage({
    sportTypeId,
    search,
    participantType
  })
  return response.clubs ?? []
}
